import { Component } from '@angular/core';

@Component({
  selector: 'app-timetable-entries',
  templateUrl: './timetable-entries.component.html',
  standalone: false,
})
export class TimetableEntriesComponent {}
